import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft, Gamepad2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import Logo from "@/components/Logo";

const FADE_UP = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } };
const CARD_ANIM = { initial: { opacity: 0, scale: 0.95 }, animate: { opacity: 1, scale: 1 } };

export default function KioskLanding() {
  const navigate = useNavigate();
  const [contests, setContests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .listContestsPublic()
      .then(setContests)
      .catch(() => toast.error("Errore nel caricamento"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-950 via-slate-900 to-purple-950 text-white">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <button
          data-testid="kiosk-back-admin"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="h-4 w-4" /> Torna al pannello
        </button>

        <motion.div {...FADE_UP} className="text-center mb-10">
          <div className="inline-block rounded-2xl bg-white p-3 shadow-xl mb-5">
            <Logo className="h-24 sm:h-28" />
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-amber-400/15 border border-amber-400/30 px-4 py-1.5 text-amber-300 text-sm font-semibold mb-4 ml-0 sm:ml-3 align-top">
            <Sparkles className="h-4 w-4" /> Modalità Totem
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            Scegli il concorso
          </h1>
          <p className="text-white/60 mt-3 text-lg">Seleziona un concorso attivo per iniziare a giocare.</p>
        </motion.div>

        {loading && <p className="text-center text-white/60">Caricamento…</p>}
        {!loading && contests.length === 0 && (
          <div className="text-center text-white/60 rounded-2xl border border-white/10 bg-white/5 p-12">
            Nessun concorso attivo al momento.
          </div>
        )}
        {!loading && contests.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-4">
            {contests.map((c, i) => (
              <motion.button
                key={c.id}
                data-testid={`kiosk-contest-${c.id}`}
                {...CARD_ANIM}
                transition={{ delay: i * 0.06 }}
                onClick={() => navigate(`/gioca/${c.id}`)}
                className="text-left rounded-2xl bg-white/95 text-slate-900 p-6 shadow-xl hover:scale-[1.02] active:scale-95 transition-transform"
              >
                <h3 className="font-display font-bold text-2xl">{c.name}</h3>
                {c.description && <p className="text-slate-600 mt-1 line-clamp-2">{c.description}</p>}
                <div className="flex items-center gap-2 mt-4 text-emerald-600 font-semibold">
                  <Gamepad2 className="h-5 w-5" /> Gioca ora
                </div>
              </motion.button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
